/*
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-09-21 11:31:55
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-09-21 15:04:21
 */
import api from '@/api/list';
const custom = {
  state: {
    customerServiceObjClose: 1, // 显示平台客服电话
    customerServiceObjPhoneNumber: null,
    mobileDefaultAvatar: null,
    loadingImg: null,
    title:null,
    faviconlogo:null
  },
  mutations: {
    SET_CUSTOMER_SERVICE_OBJ_CLOSE: (state, customerServiceObjClose) => {
      state.customerServiceObjClose = customerServiceObjClose;
    },
    SET_CUSTOMER_SERVICE_OBJ_PHONENUMBER: (state, customerServiceObjPhoneNumber) => {
      state.customerServiceObjPhoneNumber = customerServiceObjPhoneNumber;
    },
    SET_MOBILE_DEFAULT_AVATAR: (state, mobileDefaultAvatar) => {
      state.mobileDefaultAvatar = mobileDefaultAvatar;
    },
    SET_LOADING_IMG: (state, loadingImg) => {
      state.loadingImg = loadingImg;
    },
   SET_TITLE: (state, title) => {
      state.title = title;
    },
   SET_FAVICON_LOGO: (state, faviconLogo) => {
      state.faviconLogo = faviconLogo;
    }
  },
  actions: {
    // 获取用户信息
    GetCustomCompanyInfo({
      commit,
      state
    },ecompanyCode) {
      return new Promise((resolve, reject) => {
        api.getCustomCompanyInfo({ ecompanyCode: ecompanyCode }).then(response => {
          if (response != null && response.data != null && response.data.value != null) {
            const value = response.data.value;
            let data = JSON.parse(value);
            commit('SET_CUSTOMER_SERVICE_OBJ_CLOSE', data.customerServiceObj.close);
            commit('SET_CUSTOMER_SERVICE_OBJ_PHONENUMBER', data.customerServiceObj.phoneNumber);
            commit('SET_MOBILE_DEFAULT_AVATAR', data.mobileDefaultAvatar);
            commit('SET_LOADING_IMG', data.loadingImg);
            commit('SET_TITLE', data.title);
            commit('SET_FAVICON_LOGO', data.faviconLogo);
            resolve(response);
          }
        }).catch(error => {
          reject(error);
        });

      });
    }
  }
}
export default custom;
